import clsx from "clsx";
import { useFormik } from "formik";
import { useEffect } from "react";
import { addBulkLanguage } from "../app/request/languageRequest";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { languages } from "prismjs";
import MultipleCheckBoxSkeleton from "../components/Skeletons/MultipleCheckBox";
import TableView from "../components/TableView";
import Badge from "../components/Badge";
import moment from "moment";
import { initOnLoad } from "apexcharts";
import TableBody from "../components/TableView/TableBody";
import Multiselect from "multiselect-react-dropdown";
import Select from "../components/CustomSelect";
import SelectComponent from "../components/CustomSearchSelect";
import DropBox from "../components/DropBox";
import InputField from "../components/Input";
import CustomCrossButton from "../utils/CustomStyleComponent/CrossButtonComponent";
import CustomArrow from "../utils/CustomStyleComponent/ArrowComponent";
import CustomTooltip from "../utils/CustomStyleComponent/TooltipComponent";
import "./UploadAccessoryForm.css";
import CustomTooltip1 from "../utils/CustomStyleComponent/TooltipNewComponent";

const columns = [
  {
    name: "AccessoryName",
    renderHeader: (rows: any) => (
      <>
        <b>Name</b>
      </>
    ),
    renderCell: (row: any) => <>{row?.accessoryName?.slice(0, 20)}</>,
  },
  {
    name: "Region",
    renderHeader: (rows: any) => (
      <>
        <b>Regions</b>
      </>
    ),
    renderCell: (row: any) => <>{row?.regions?.[`0`]?.regionName}</>,
  },

  {
    name: "status",
    renderHeader: (rows: any) => (
      <>
        <b>Status</b>
      </>
    ),
    renderCell: (row: any) => (
      <Badge
        variant={row?.isAdded == true  ? "success" : "danger"}
        className="fs-7 fw-bolder"
      >
        {row?.isAdded === true 
          ? "Successfully Created/Updated"
          : row?.message || "Not Found,InActive or Duplicate"}



      </Badge>
    ),
  },
];



const findBestMatch = (attributeName: string, headers: string[]) => {
  // Convert attribute name to lowercase for case-insensitive matching
  const attrNameLower = attributeName.toLowerCase();
  
  // First try exact match (case insensitive)
  const exactMatch = headers.find(header => header.toLowerCase() === attrNameLower);
  if (exactMatch) return exactMatch;
  
  // Then try contains match
  const containsMatch = headers.find(header => 
    header.toLowerCase().includes(attrNameLower) || 
    attrNameLower.includes(header.toLowerCase())
  );
  if (containsMatch) return containsMatch;
  
  return null;
}





const UploadAccessoryForm = ({
  category,
  regions,
  handleFileChange,
  setFieldValue,
  values,
  setFieldTouched,
  touched,
  displayUploadResults,
  uploadResults,
  errors,
  headers,
  staticAttributes,
  isloading,
  handleGoBack,
  slideIn,
  slideOut,
}: {
  category: any;
  regions: any;
  displayUploadResults: any;
  uploadResults: any;
  setFieldValue: any;
  values: any;
  isloading: boolean;
  errors: any;
  touched: any;
  setFieldTouched: any;
  handleFileChange: any;
  headers: any;
  staticAttributes: any;
  handleGoBack: () => void;
  slideIn: string;
  slideOut: string;
}) => {
  console.log(uploadResults, "uploadResults");
  console.log(displayUploadResults, "displayUploadResults");

  function useHeaderMapping(headers : any, values :any, staticAttributes : any, setFieldValue : any) {
    useEffect(() => {
      // Force component to recognize this is a new call
      const timerRef = setTimeout(() => {
        if (headers && headers.length > 0) {
          console.log("Mapping effect running with:", {headers, subcategory: values?.subcategory?.[0]});
          
          // Static mapping logic
          const staticMappings = { ...values.staticAttributesMapping || {} };
          staticAttributes.forEach((attribute : any) => {
            const match = findBestMatch(attribute.name, headers);
            if (match) {
              staticMappings[attribute.name] = match;
            }
          });
          
          // Attribute mapping logic
          if (values?.subcategory?.[0]?.supportedAttributes) {
            const attributesMappings = [...(values.attributesMapping || [])];
            const existingMappedAttrs = attributesMappings.map(attr => attr.attributeName);
            
            values.subcategory[0].supportedAttributes.forEach((attribute : any) => {
              if (!existingMappedAttrs.includes(attribute.attributeName)) {
                const match = findBestMatch(attribute.attributeName, headers);
                if (match) {
                  const defaultUnit = attribute.supportedUnits?.[0] || {};
                  attributesMappings.push({
                    attributeName: attribute.attributeName,
                    value: match,
                    unit: {
                      _id: defaultUnit._id,
                      name: defaultUnit.name
                    },
                    translations: attribute.translations
                  });
                }
              } else {
                // For existing mappings, ensure they have the default unit if not already set
                const existingIndex = attributesMappings.findIndex(
                  attr => attr.attributeName === attribute.attributeName
                );
                if (existingIndex !== -1 && !attributesMappings[existingIndex].unit) {
                  const defaultUnit = attribute.supportedUnits?.[0] || {};
                  attributesMappings[existingIndex].unit = {
                    _id: defaultUnit._id,
                    name: defaultUnit.name
                  };
                }
              }
            });
            
            // Set both values with short delay between them
            setFieldValue("staticAttributesMapping", staticMappings);
            setTimeout(() => {
              setFieldValue("attributesMapping", attributesMappings);
            }, 10);
          } else {
            setFieldValue("staticAttributesMapping", staticMappings);
          }
        }
      }, 0);
      
      return () => clearTimeout(timerRef);
    }, [headers, JSON.stringify(values.subcategory), JSON.stringify(staticAttributes)]);
  }

  useHeaderMapping(headers, values, staticAttributes, setFieldValue);

  const style = {
    multiSelectContainer: {
      minheight: "44px",
      border: "1px solid var(--bs-gray-100)",
      // styles for the multiselect container
    },
    searchBox: {
      minheight: "44px",
      fontWeight: "500",
      minwidth: "40px",
      maxwidth: "40px",
      height: "44px",
      display: "flex",
      alignItems: "center",
      // styles for the search wrapper
    },
    chips: {
      // To change css chips(Selected options)
      marginBottom: "0",
    },
  };
 

  return (
    <>
      <div className="card p-5 pb-0">
        <div className="container p-0 m-0">
          <div className="row ">
          <div className="col-md-12">
              <div className="justify-content-left">
              <p className="text-danger fs-3 fw-bold">Note: Please don't do bulk upload on prod- Do it /Test first in dev</p>
                <label className="form-label fs-6 fw-bolder text-dark ">
                Sample File
                </label>
                <button className="btn btn-primary ms-5">
                  <a
                    href="/static-files/Bulk_Upload_Accessory_Standared_Sheet.xlsx"
                    download
                    className="text-white"
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px"><path opacity="0.3" d="M19 15C20.7 15 22 13.7 22 12C22 10.3 20.7 9 19 9C18.9 9 18.9 9 18.8 9C18.9 8.7 19 8.3 19 8C19 6.3 17.7 5 16 5C15.4 5 14.8 5.2 14.3 5.5C13.4 4 11.8 3 10 3C7.2 3 5 5.2 5 8C5 8.3 5 8.7 5.1 9H5C3.3 9 2 10.3 2 12C2 13.7 3.3 15 5 15H19Z" fill="currentColor"></path><path d="M13 17.4V12C13 11.4 12.6 11 12 11C11.4 11 11 11.4 11 12V17.4H13Z" fill="currentColor"></path><path opacity="0.3" d="M8 17.4H16L12.7 20.7C12.3 21.1 11.7 21.1 11.3 20.7L8 17.4Z" fill="currentColor"></path></svg> Download Sample File
                  </a>
                </button>
                <div className="mt-3">
                  <p className="text-primary fs-5 fw-bold">Download the sample template above, fill it with your Accessories details, and upload the updated file here.</p>
                </div>
              </div>
            </div>
            <hr></hr>

            <div
              className="col-md-4 p-5 border shadow card "
              style={{ position: "sticky" }}
            >
              <div className="mb-5">
                <label className="form-label fs-6 fw-bolder text-dark required ">
                  Select File
                </label>
                <div>
                  <DropBox
                    onChange={(e: any) => handleFileChange(e)}
                    multiple={false}
                    maxFiles={1}
                  />
                  <input
                    value={values?.files?.[0]?.name}
                    disabled={true}
                    className={clsx("form-control bg-transparent", {
                      "is-invalid":
                        touched?.storeMappedProduct &&
                        errors?.storeMappedProduct,
                    })}
                    type="text"
                  />
                </div>
              </div>
              <div className="mb-5">
                <label className="form-label fs-6 fw-bolder text-dark required ">
                  Regions
                </label>
                <div>
                  <Multiselect
                    options={regions && regions}
                    selectionLimit={1}
                    disable={isloading}
                    displayValue={"regionName"}
                    style={style}
                    hidePlaceholder={true}
                    customCloseIcon={<CustomCrossButton />}
                    placeholder="Select Regions"
                    onSelect={async (e) => {
                      await setFieldValue("regions", e);
                      setFieldTouched("regions");
                    }}
                    onRemove={async (e) => {
                      await setFieldValue("regions", e);
                      setFieldTouched("regions");
                    }}
                    selectedValueDecorator={(value: string, option: any) => {
                      return <CustomTooltip value={value} option={option} />;
                    }}
                  />
                </div>
              </div>
              <div className="mb-5">
                <label className="form-label fs-6 fw-bolder text-dark required ">
                  Category
                </label>
                <div>
                  <Multiselect
                    options={category && category}
                    selectionLimit={1}
                    disable={isloading}
                    displayValue={"categoryName"}
                    placeholder="Select category"
                    style={style}
                    hidePlaceholder={true}
                    customCloseIcon={<CustomCrossButton />}
                    onSelect={async (e) => {
                      await setFieldValue("category", e);
                      setFieldTouched("category");
                    }}
                    onRemove={async (e) => {
                      await setFieldValue("category", e);
                      setFieldTouched("category");
                    }}
                    selectedValueDecorator={(value: string, option: any) => {
                      return <CustomTooltip value={value} option={option} />;
                    }}
                  />
                </div>
              </div>
              <div className="mb-5">
                <label className="form-label fs-6 fw-bolder text-dark required ">
                  Subcategory
                </label>
                <div>
                  <Multiselect
                    options={values?.category?.[`0`]?.subcategory}
                    selectionLimit={1}
                    disable={
                      values?.category?.length > 0 || isloading ? false : true
                    }
                    displayValue={"subcategoryName"}
                    placeholder={
                      values?.category?.length > 0
                        ? "Select Subcategory"
                        : "Select Category First"
                    }
                    style={style}
                    hidePlaceholder={true}
                    customCloseIcon={<CustomCrossButton />}
                    onSelect={async (e) => {
                      await setFieldValue("subcategory", e);
                      setFieldTouched("subcategory");
                      
                      // Updated to include default units properly
                      let attributesForSubCategory =
                        e?.[0]?.supportedAttributes.map((attributes: any) => {
                          const defaultUnit = attributes?.supportedUnits?.[0] || {};
                          return {
                            attributeName: attributes?.attributeName,
                            unit: {
                              _id: defaultUnit._id,
                              name: defaultUnit.name
                            },
                            ...(attributes?.icecatName && {
                              icecatName: attributes?.icecatName,
                            }),
                          };
                        });
                      setFieldValue(
                        "attributesArray",
                        attributesForSubCategory
                      );
                      
                      // Initialize attribute mappings with default units
                      if (headers && headers.length > 0) {
                        const initialMappings = e?.[0]?.supportedAttributes.map((attribute: any) => {
                          const defaultUnit = attribute?.supportedUnits?.[0] || {};
                          const match = findBestMatch(attribute.attributeName, headers);
                          return {
                            attributeName: attribute.attributeName,
                            value: match || "", // Use auto-mapped header or empty string
                            unit: {
                              _id: defaultUnit._id,
                              name: defaultUnit.name
                            },
                            translations: attribute.translations
                          };
                        }).filter((mapping: any) => mapping.value); // Only keep mappings that found a match
                        
                        setFieldValue("attributesMapping", initialMappings);
                      } else {
                        // When no headers yet, initialize with empty array
                        // They'll be populated by the useEffect when headers are available
                        setFieldValue("attributesMapping", []);
                      }
                    }}
                    onRemove={async (e) => {
                      await setFieldValue("subcategory", e);
                      setFieldTouched("subcategory");
                    }}
                    selectedValueDecorator={(value: string, option: any) => {
                      return <CustomTooltip value={value} option={option} />;
                    }}
                  />
                </div>
              </div>
              {displayUploadResults && (
                <div
                  className="mt-7 d-flex justify-content-end"
                  onClick={handleGoBack}
                >
                  <span className="btn btn-primary">
                    <i className="fa-solid fa-arrow-left fs-2"></i>
                  </span>
                </div>
              )}
            </div>
            {displayUploadResults ? (
              <div className={`content col-md-8 ${slideIn}`}>
                <div className="d-flex justify-content-center">
                  {uploadResults?.newAccessoriesCount ? <Badge
                    variant="success"
                    className="fs-6 mb-5 me-5 fw-bolder"
                  >
                    {"Successfully Added: "}
                    
                    {uploadResults?.newAccessoriesCount}{" "}
                  </Badge> : ""}
                  
                  {uploadResults?.updatedAccessoriesCount ? <Badge
                    variant="success"
                    className="fs-6 mb-5 me-5 fw-bolder"
                  >
                    {"Successfully Updated: "}
                    {uploadResults?.updatedAccessoriesCount}{" "}
                  </Badge> : ""}
                  
                  <Badge
                    variant="danger"
                    className="fs-6 mb-5 ms-5 fw-bolder"
                  >
                    {"Not Added:"}
                    {uploadResults?.duplicateAccessoriesCount}{" "}{"Duplicate Found"}
                  </Badge>
                </div>
                <TableView
                  rows={uploadResults?.allAccessories || []}
                  columns={columns}
                  showPagination={false}
                  showSearch={false}
                  showPerPage={false}
                  showFilter={false}
                />
              </div>
            ) : (
              <div
                className={`content col-md-8`}
                style={{ maxHeight: "550px", overflowY: "auto" }}
              >
                <div className="col-md-12">
                  <div className="d-flex justify-content-center">
                    <h5 className="fw-bolder mb-5">Specifications</h5>
                  </div>
                  <div className="card p-5 shadow d-flex flex-row flex-wrap mb-3 d-flex">
                    {staticAttributes.map((attribute: any) => {
                      return (
                        <div
                          key={attribute._id || attribute.name}
                          className="row me-2 mb-2"
                          style={{ width: "50%" }}
                        >
                          <div className="w-100px">
                            <label className="col-form-label required fw-bold fs-6">
                              {attribute && attribute.name}
                            </label>
                          </div>

                          <div>
                            <Multiselect
                              options={headers}
                              isObject={false}
                              disable={isloading}
                              selectionLimit={1}
                              style={style}
                              hidePlaceholder={true}
                              customCloseIcon={<CustomCrossButton />}
                              onSelect={async (e) => {
                                let mapping = values.staticAttributesMapping || {};
                                let newobject = {
                                  ...mapping,
                                  [`${attribute.name}`]: e?.[0],
                                };
                                await setFieldValue(
                                  "staticAttributesMapping",
                                  newobject
                                );
                                setFieldTouched("staticAttributesMapping");
                              }}
                              selectedValues={values?.staticAttributesMapping?.[attribute.name] ? 
                                [values.staticAttributesMapping[attribute.name]] : 
                                []
                              }
                              selectedValueDecorator={(
                                value: string,
                                option: any
                              ) => {
                                return (
                                  <CustomTooltip
                                    value={value}
                                    option={option}
                                  />
                                );
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {values?.subcategory?.[`0`]?.supportedAttributes && (
                    <div className="card p-5 shadow mb-5">
                      {values?.subcategory?.[`0`]?.supportedAttributes.map(
                        (attribute: any) => {
                          // Find if there's an existing mapping for this attribute
                          const existingMapping = values.attributesMapping?.find(
                            (mapping: any) => mapping.attributeName === attribute.attributeName
                          );
                          
                          // Get default unit for the attribute
                          const defaultUnit = attribute.supportedUnits?.[0] || {};
                          
                          return (
                            <div key={attribute._id} className="row mb-3">
                              <label className="col-lg-4 col-form-label required fw-bold fs-6 ">
                                {attribute && attribute.attributeName}
                              </label>

                              <div className="col-lg-4">
                                <select
                                  className="form-select form-select-white"
                                  onChange={(e: any) => {
                                    if (e.target.value === "Please choose one option") return;
                                    
                                    let temp = JSON.parse(e.target.value);
                                    const selectedUnit = {
                                      _id: temp._id,
                                      name: temp.name,
                                    };
                                    
                                    // Update existing mapping or prepare for new one
                                    const mappingIndex = values.attributesMapping?.findIndex(
                                      (mapping: any) => mapping.attributeName === attribute.attributeName
                                    );
                                    
                                    if (mappingIndex !== -1) {
                                      const updatedMappings = [...values.attributesMapping];
                                      updatedMappings[mappingIndex].unit = selectedUnit;
                                      setFieldValue("attributesMapping", updatedMappings);
                                    } else {
                                      // Create new mapping with this unit
                                      const newMapping = {
                                        attributeName: attribute.attributeName,
                                        value: "",
                                        unit: selectedUnit,
                                        translations: attribute.translations
                                      };
                                      setFieldValue("attributesMapping", [...(values.attributesMapping || []), newMapping]);
                                    }
                                  }}
                                >
                                  <option>Please choose one option</option>
                                  {attribute &&
                                    attribute.supportedUnits &&
                                    attribute.supportedUnits.map(
                                      (option: any, index: any) => {
                                        // Find if there's an existing mapping for this attribute
                                        const existingMapping = values.attributesMapping?.find(
                                          (mapping: any) => mapping.attributeName === attribute.attributeName
                                        );
                                        
                                        // Determine if this option should be selected
                                        const isSelected = existingMapping?.unit?._id === option._id || 
                                                          (!existingMapping?.unit && index === 0);
                                        
                                        return (
                                          <option
                                            key={index}
                                            value={JSON.stringify(option)}
                                            selected={isSelected}
                                          >
                                            {option.name}
                                          </option>
                                        );
                                      }
                                    )}
                                </select>
                              </div>
                              <div className="col-lg-4">
                                <Multiselect
                                  options={headers}
                                  isObject={false}
                                  disable={isloading}
                                  selectionLimit={1}
                                  style={style}
                                  hidePlaceholder={true}
                                  customArrow={<CustomArrow />}
                                  customCloseIcon={<CustomCrossButton />}
                                  singleSelect={true}
                                  selectedValues={existingMapping?.value ? [existingMapping.value] : []}
                                  onSelect={async (e) => {
                                    const selectedValue = e?.[0];
                                    if (!selectedValue) return;
                                    
                                    let mapping = [...(values.attributesMapping || [])];
                                    const existingIndex = mapping.findIndex(
                                      (m: any) => m.attributeName === attribute.attributeName
                                    );
                                    
                                    // Get the selected unit or use the first one as default
                                    const selectedUnit = attribute.selectedUnit || 
                                      (existingIndex !== -1 ? mapping[existingIndex].unit : {
                                        _id: defaultUnit._id,
                                        name: defaultUnit.name
                                      });
                                      
                                    if (existingIndex !== -1) {
                                      // Update existing mapping
                                      mapping[existingIndex].value = selectedValue;
                                      if (!mapping[existingIndex].unit && selectedUnit) {
                                        mapping[existingIndex].unit = selectedUnit;
                                      }
                                    } else {
                                      // Create new mapping
                                      mapping.push({
                                        attributeName: attribute.attributeName,
                                        value: selectedValue,
                                        unit: selectedUnit,
                                        translations: attribute.translations,
                                      });
                                    }

                                    await setFieldValue("attributesMapping", mapping);
                                    setFieldTouched("attributesMapping");
                                  }}
                                  onRemove={async () => {
                                    // Remove this attribute from mappings
                                    const updatedMappings = values.attributesMapping.filter(
                                      (mapping: any) => mapping.attributeName !== attribute.attributeName
                                    );
                                    await setFieldValue("attributesMapping", updatedMappings);
                                    setFieldTouched("attributesMapping");
                                  }}
                                  selectedValueDecorator={(
                                    value: string,
                                    option: any
                                  ) => {
                                    return (
                                      <CustomTooltip1
                                        value={value}
                                        option={option}
                                      />
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadAccessoryForm;
